import PageHeader from "@/components/site/PageHeader";
import ContactForm from "@/components/sections/ContactForm";
import { motion } from "framer-motion";
import {
  CreditCard,
  TrendingUp,
  GraduationCap,
  Home as HomeIcon,
  FileSearch,
  CheckCircle2,
} from "lucide-react";
import { useI18n } from "@/i18n/i18n";

const ICONS = [CreditCard, TrendingUp, GraduationCap, HomeIcon, FileSearch];

export default function Services() {
  const { tr } = useI18n();
  return (
    <div data-testid="services-page">
      <PageHeader
        overline={tr.services_page.overline}
        title={tr.services_page.title}
        subtitle={tr.services_page.subtitle}
      />

      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {tr.services_page.items.map((s, i) => {
              const Icon = ICONS[i] || CreditCard;
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.55, delay: i * 0.05 }}
                  className="mc-card p-10"
                  data-testid={`service-detail-${i}`}
                >
                  <div className="h-14 w-14 rounded-2xl bg-[color:var(--mc-primary)]/20 border border-[color:var(--mc-cyan)]/30 text-[color:var(--mc-cyan)] flex items-center justify-center">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="font-heading text-2xl font-semibold tracking-tight mt-6 text-white">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-white/70 leading-relaxed">{s.desc}</p>
                  <ul className="mt-6 grid grid-cols-2 gap-3">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-sm text-white/85">
                        <CheckCircle2 className="h-4 w-4 text-[color:var(--mc-gold)] shrink-0" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <ContactForm />
    </div>
  );
}
